import React from 'react';
import { getPwaWorkspaceConfig } from '../../config/workspace-config';

interface AuthSelectScreenProps {
  onLogin: () => void;
  onSignup: () => void;
}

export const AuthSelectScreen: React.FC<AuthSelectScreenProps> = ({ onLogin, onSignup }) => {
  const wsConfig = getPwaWorkspaceConfig();
  const appName = wsConfig.appName || 'Console';

  return (
    <div className="pwa-auth-container">
      <h1 className="pwa-auth-title">{appName.toUpperCase()}</h1>
      <p className="pwa-auth-subtitle">Direct player portal gateway</p>

      <button onClick={onLogin} className="pwa-primary-btn">
        SIGN IN
      </button>

      <button onClick={onSignup} className="pwa-secondary-btn">
        REGISTER
      </button>
    </div>
  );
};
